import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'stationary_compressed_gas_cylinders_are_not_connected_fixed'

export const dataPointDefinition = {
  retracedId: 'stationary_compressed_gas_cylinders_are_not_connected_fixed',
  name: 'Stationary compressed gas cylinders are not connected with fixed piping',
  description: 'If the facility only has cylinders that are mobile, select Not Applicable.',
  meta: {
    slcpMeta: {
      key: 'hs-che-52x',
      number: 'HS-CHE-18-8',
      dataType: 'array',
      masterType: 'Question',
      multiSelectKey: 'hs-che-44',
      optionList: 'xna',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-28,Yes',
      machineShowHide: '[2],hs-28,1',
      completionCondition: 'any ms',
    },
    multiSelectKey: 'hs-che-44',
  },
  fieldTypeId: 'MULTI_SELECT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'xna',
      name: 'xna',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'string',
          enum: ['xna'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-che-52x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 30400,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
